// ======================================================================
// File Name       : ContentDistributionUtils
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { CONTENT_DISTRIBUTION_TYPE, DRILL, VIDEO, DOCUMENT, LINK } from '../constants/ContentDistributionConstant';

/**
 * @param object data content distribution
 * @return string distribution type
 */
export function getDistributionTypeName(data) {
  let name = '';
  if (data.drillDistributionExistence) {
    name += getItemName(CONTENT_DISTRIBUTION_TYPE, DRILL);
    name += ', ';
  }
  if (data.videoDistributionExistence) {
    name += getItemName(CONTENT_DISTRIBUTION_TYPE, VIDEO);
    name += ', ';
  }
  if (data.documentDistributionExistence) {
    name += getItemName(CONTENT_DISTRIBUTION_TYPE, DOCUMENT);
    name += ', ';
  }
  if (data.linkDistributionExistence) {
    name += getItemName(CONTENT_DISTRIBUTION_TYPE, LINK);
    name += ', ';
  }
  if (name) {
    name = name.trim();
    name = name.slice(0, -1);
  }
  return name;
}

/**
 * @param object dataList
 * @param string val
 * @return string name
 */
function getItemName(dataList, val) {
  let name = '';
  dataList.forEach(function (item) {
    if (parseInt(item.value, 10) === parseInt(val, 10)) {
      name = item.name;
    }
  }, this);
  return name;
}

/**
 * @param string typeValue
 * @param string selectedValue
 * @return int 0|1
 */
export function getContentDistributionTypeValue(typeValue, selectedValue) {
  if (selectedValue === '') {
    return 0;
  }
  if (parseInt(typeValue, 10) === parseInt(selectedValue, 10)) {
    return 1;
  }
  return 0;
}
